import React, { useEffect } from "react";
import { Button, Modal, Form, Table } from 'react-bootstrap';
import styles from '../../../styles/MP/RapportEnvioCad.module.scss';
import {useMPRapportEnvioCad} from "../../../contexts/MPRapportEnvioCadContext"

const ModalConfirmacaoGrade = () => {

    const { showConfirmacaoGrade, handleCloseConfirmacaoGrade, handleProcessConsumo, atualizaLinx, setAtualizaLinx, produtosConsumo } = useMPRapportEnvioCad();

    // Reseta o valor do atualizaLinx quando o modal é aberto
    useEffect(() => {
        if (showConfirmacaoGrade) {
            setAtualizaLinx(0);
        }
    }, [showConfirmacaoGrade, setAtualizaLinx]);

    const handleCheckboxChange = (e) => {
        setAtualizaLinx(e.target.checked ? 1 : 0);
    };

    // Verifica se existe pelo menos um item com IdStatusFinal = 4 (aprovado)
    const temItemAprovado = produtosConsumo.some(produto => produto.IdStatusFinal == 4);
    
    return (
        <Modal
            show={showConfirmacaoGrade}
            onHide={handleCloseConfirmacaoGrade}
            backdrop="static"
            keyboard={false}
            centered
        >
        <Modal.Header>
            <Modal.Title>Essas informações serão salvas:</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h5>Deseja realmente salvar as informações de novo consumo?</h5>
            {temItemAprovado && (
                <Form.Group className="mt-3">
                    <Form.Check
                        type="checkbox"
                        label="Deseja também atualizar o consumo no Linx?"
                        checked={!!atualizaLinx}
                        onChange={handleCheckboxChange}
                    />
                </Form.Group>
            )}
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
            <Button
                variant="success"
                className={styles.modalBtn}
                onClick={() => handleProcessConsumo(atualizaLinx)}
            >
                Confirmar
            </Button>
            <Button
                variant="outline-danger"
                className={styles.modalBtn}
                onClick={handleCloseConfirmacaoGrade}
            >
                Voltar
            </Button>
        </Modal.Footer>
      </Modal>
    ) 
}

export default ModalConfirmacaoGrade;
